import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareAndroid2 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <circle
      cx={16}
      cy={7}
      r={3}
      fill='#fff'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m12.875 8.563-4.062 2.03m4.062 4.845-4.062-2.032'
    />
    <circle
      cx={6}
      cy={12}
      r={3}
      fill='#fff'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx={16}
      cy={17}
      r={3}
      fill='#fff'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareAndroid2)
export default ForwardRef
